import { createFileRoute } from "@tanstack/react-router";
import { UseCasesPage } from "@/components/blocks/use-cases/UseCasesPage";
import {
	buildPageBreadcrumb,
	buildPageSeo,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/cas-usage/")({
	component: UseCasesPage,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData
			? buildPageSeo("useCases", loaderData.locale, {
					structuredData: [
						buildPageBreadcrumb(loaderData.locale, ["useCases"]),
					],
				})
			: {},
});
